module.exports = __webpack_public_path__ + "img/mano.32096d84.svg";